import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @rushstack/no-new-null */
import { useState } from 'react';
import { IconButton } from '@mui/material';
import ContentCopySharpIcon from '@mui/icons-material/ContentCopySharp';
import { Snackbar } from '../../atoms/Snackbar';
import { Tooltip } from '../../atoms/Tooltip';
const CopyIcon = ({ name, value }) => {
    const [showMessage, setShowMessage] = useState(false);
    const [showSnackBarMsg, setSnackBarMsg] = useState(`${name} copied`);
    const toggleShowMessage = () => {
        setShowMessage(!showMessage);
    };
    const closeSnackbar = async () => {
        setShowMessage(false);
    };
    const handleClickIcon = async (value) => {
        try {
            if (value) {
                await navigator.clipboard.writeText(value.toString());
            }
        }
        catch (error) {
            setSnackBarMsg(`Failed to copy ${name}: ${error}`);
        }
        toggleShowMessage();
    };
    const snackBar = (_jsx(Snackbar, { isOpen: showMessage, message: showSnackBarMsg, positionHorizontal: "center", positionVertical: "bottom", onClose: closeSnackbar }));
    const tooltipText = `Copy ${name}`;
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { text: tooltipText, placement: "right", children: _jsx(IconButton, { edge: "end", sx: { margin: 0 }, onClick: () => handleClickIcon(value), children: _jsx(ContentCopySharpIcon, { sx: { color: 'action.active' } }) }) }), snackBar] }));
};
export default CopyIcon;
//# sourceMappingURL=index.js.map